/**
 * Imports the BASE URL from the config.
 */
import { FH_CONFIG } from '../config.js';

export default {
    /**
     * GET /settings/locations/default-pickup
     */
    getDefaultPickupLocation: function(){
        return axios.get( '/settings/locations/default-pickup');
    },
}